class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    updateFreeShippingNotice();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
  this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
  this.productId = parsedState.id;
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);
    sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
  });

  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.open();

    // Recalcule la barre livraison offerte APRES le rendu complet
    updateFreeShippingNotice();
  });
}

  

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function updateFreeShippingNotice() {
  const noticeEl = document.getElementById('free-shipping-notice');
  if (!noticeEl) return;

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const RELAY = 49; // EUR seuil relais
      const HOME = 69; // EUR seuil domicile

      // items_subtotal_price = somme des lignes apres remises (en centimes)
      const current = (cart.items_subtotal_price || 0) / 100;

      const leftRelay = Math.max(0, RELAY - current);
      const leftHome = Math.max(0, HOME - current);
      const relayOn = current >= RELAY;
      const homeOn = current >= HOME;
      const fillPct = Math.min(current / HOME, 1) * 100;
      const relayPct = (RELAY / HOME) * 100;

      const fmt = (v) => v.toFixed(2).replace('.', ',') + ' €';

      let msg;
      if (homeOn) {
        msg = '✅ <strong>Livraison offerte !</strong> 🎉';
      } else if (relayOn) {
        msg = '✅ <strong>Livraison en point relais offerte !</strong> Plus que <strong>' + fmt(leftHome) + '</strong> pour la livraison à domicile offerte.';
      } else {
        msg = '🚚 Plus que <strong>' + fmt(leftRelay) + '</strong> pour la livraison en point relais offerte !';
      }

      const check = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

      noticeEl.className = 'mkz-ship';
      noticeEl.innerHTML =
        '<div class="mkz-ship__msg">' + msg + '</div>' +
        '<div class="mkz-ship__bar">' +
          '<div class="mkz-ship__fill" style="width:' + fillPct.toFixed(2) + '%"></div>' +
          '<span class="mkz-ship__tick mkz-ship__tick--relay' + (relayOn ? ' is-on' : '') + '" style="left:' + relayPct.toFixed(2) + '%">' + check + '</span>' +
          '<span class="mkz-ship__tick mkz-ship__tick--home' + (homeOn ? ' is-on' : '') + '" style="left:100%">' + check + '</span>' +
        '</div>';
    });
}